const _ = "";
export {
  _ as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/guahuabihua/guahuabihua.vue3.js
// module id = 1257
// module chunks = 67